import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
//import Image from '../components/image'
import SEO from '../components/seo'

import Checkout from '../components/checkout'

const IndexPage = () => (
  <Layout>
    <SEO title="Accueil" keywords={[`gatsby`, `application`, `react`]} />
    <h2>Quête et offrandes X-Mémorial</h2>
    <p>peuvent se faire sur ce site sécurisé (https), 24h/24 7j/7 en tous lieux éventuellement sur votre portable.</p>
    
    <p><Checkout /></p>
    <Link to="/advanced/">AUTRES CHOIX (1 à 200€) !</Link>
    
    <p></p>
    
  </Layout>
)

export default IndexPage
